import React, {useEffect} from 'react';  
import { useSelector, useDispatch } from "react-redux";
import { Toast} from 'react-bootstrap'  
function ToastErrorMessage(props) { 

    const {apiData} = useSelector(state => state);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch({type: "API_LOADER_STOP"}) 
        setTimeout(() => { 
            dispatch({type: "API_DATA_DESTROY"})
        }, 2000) 
    }, [])

   
  
    return (
        <Toast className="toast-message-box toast-error-message"  show={true} delay={3000} autohide={true}>
                <Toast.Header> 
                <strong className="mr-auto">Error</strong> 
                </Toast.Header>
                <Toast.Body>{apiData.message}</Toast.Body>
            </Toast>
    );
  }
  
  export default ToastErrorMessage;